import { render, staticRenderFns } from "./home.vue?vue&type=template&id=12b4e455&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=12b4e455&prod&scoped=true&lang=css"
import style1 from "./home.vue?vue&type=style&index=1&id=12b4e455&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4e455",
  null
  
)

export default component.exports